/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../../shared/generated.types'

import { api } from '../../../utils'
export const EligibilityVerificationExternalFrag = `
    fragment EligibilityVerificationExternalFrag on EligibilityVerificationExternal {
  id
  billingInsuranceId
  ts
  payerId
  providerName
  providerNpi
  location
  insured {
    patientRelationship
    firstName
    lastName
    dob
    dateOfServiceStart
    dateOfServiceEnd
    memberId
  }
  vendor
  isActive
  benefitSummaryPdfFile
  requestId
  insurancePlanId
  coPay
  deductible
  familyDeductible
  coinsurance
}
    `
export const VerifyEligibilityExternalDocument = `
    mutation verifyEligibilityExternal($input: [VerifyEligibilityExternalInput!]!) {
  verifyEligibilityExternal(input: $input) {
    ...EligibilityVerificationExternalFrag
  }
}
    ${EligibilityVerificationExternalFrag}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    verifyEligibilityExternal: build.mutation<
      Types.VerifyEligibilityExternal,
      Types.VerifyEligibilityExternalVariables
    >({
      query: (variables) => ({
        document: VerifyEligibilityExternalDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
